<template>
  <sui-card class="state-card">
    <sui-card-content class="compact state-header">
      <b>Configuration</b>
    </sui-card-content>
    <sui-card-content>
      <i class="huge fitted icon" :class="isMigrated ? 'cubes' : 'cube'" />
      <b>{{service.configuration}}</b>
    </sui-card-content>
    <sui-button-group class="fluid" size="mini" attached="bottom">
      <sui-button :disabled="isMigrateDisabled" data-goal="SERVICE_PAGE_MIGRATE" @click="$modals.scaleService.open(service)">Migrate</sui-button>
    </sui-button-group>
  </sui-card>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'ServiceConfigurationCard',
    props: {
      service: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['actionsById']),
      actions() {
        return this.actionsById[this.service.id]
      },
      inProgress() {
        return this.service._inProgress
      },
      isOffline() {
        return this.service._isOffline
      },
      isMigrated() {
        const enumItems = this.service.constructor.fields.configuration.enum
        return enumItems ? this.service.configuration === enumItems[1].value : false
      },
      isMigrateDisabled() {
        return this.inProgress || this.isOffline || this.isMigrated || !this.actions.serviceScale
      },
    },
  }
</script>
